<template>
  <div>
    <van-nav-bar title="我的请假申请" left-text="返回" left-arrow @click-left="onClickLeft" @click-right="onClickRight">
      <template slot="right">
        <van-icon name="edit" size="25"/>
      </template>
    </van-nav-bar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        :immediate-check="false"
        @refresh="onRefresh"
        @load="onLoad">
        <van-swipe-cell v-for="item in list" :key="item.id" disabled>
            <van-card :tag=item.statusName
                      :title=holidayTitle(item.name,item.deptName)
                      class="goods-card"
                      @click="jumpToApplyPage(item.status, item.taskId, item.processInstanceId, item.appNo, item.processDefinitionId)">
              <template slot="thumb">
                <img :src="listIcon" style="width: 80px;"/>
              </template>
              <template slot="tags">
                <span>请假类型：<van-tag plain type="danger">{{ item.ruleName }}</van-tag></span><br>
                <span>开始时间：{{ item.beginTime }}</span><br>
                <span>结束时间：{{ item.endTime }}</span><br>
                <span>请假天数：{{ item.day }}</span><br>
              </template>
              <template slot="footer">
                <div>{{ item.createTime }}</div>
              </template>
            </van-card>
            <template slot="right">
              <van-button square text="删除" type="danger" class="delete-button"/>
            </template>
          </van-swipe-cell>
      </van-list>
      <van-empty description="暂无数据" v-if="emptyShow"/>
    </van-pull-refresh>
  </div>
</template>

<script>
import {Toast} from "vant";
import {isLogin, isWechat} from "../../../utils/util";

export default {
  name: "RefereeList",
  data() {
    return {
      list: [],
      listIcon: "../../../static/images/holiday_apply.png",
      loading: false,
      finished: false,
      refreshing: false,
      userId: '',
      userClassify: 0,
      userGroup: 0,
      refereeStatus: 0,
      finishedText: "上滑加载更多...",
      emptyShow: false,
      size: 10,
      current: 1,
      total: 0,
      modelKey: "Leave",
      processDefinitionId: '',
      processInstanceId: '',
      appNo: '',
      userInfo: {},
    };
  },
  mounted() {
    if(!isLogin()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
    this.loading = true;
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.$fetch("/attence-api/blade-user/info", {}).then(
        res => {
          const user = res.data;
          this.userInfo = user;
          this.getHolidayList();
        }
      );
    },
    toLeaveApply() {
      this.$fetch("/attence-api/blade-flow/process/getFlowProcessByKey", {
        modelKey: this.modelKey,
      }).then(
        res => {
          const data = res.data;
          let bladeFlow = {
            taskDefinitionKey: "apply",
            processDefinitionId: data.id,
            processDefinitionKey: data.key,
          };
          this.$bodyPost("/attence-api/blade-flow/process/startProcessApply", bladeFlow).then(
            res => {
              const data = res.data;
              Toast(res.msg);
              this.$router.push({
                path: "/attenceflow/leave/form",
                query: {
                  taskId: data.taskId,
                  processInstanceId: data.processInstanceId,
                  appNo: data.appNo,
                  processDefinitionId: data.processDefinitionId,
                  pageType: 1,
                }
              });
            }
          );
        }
      );
    },
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      } else {
        this.current++;
      }
      this.getHolidayList();
    },
    onRefresh() {
      // 清空列表数据
      this.current = 1;
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    getHolidayList: function () {
      this.$fetch("/attence-api/blade-holiday-leave/holidayleave/page", {
        current: this.current,
        size: this.size,
        createUser: this.userInfo.id
      }).then(
        res => {
          const data = res.data;
          this.list = this.list.concat(data.records);
          this.total = data.total;
          this.size = data.size;
          this.current = data.current;
          if (this.list.length > 0) {
            this.emptyShow = false;
            if (this.total > this.list.length) {
              this.finishedText = "上滑加载更多...";
            } else {
              // 数据全部加载完成
              this.finished = true;
              this.finishedText = "没有更多了";
            }
          } else {
            this.emptyShow = true;
            this.finished = true;
            this.finishedText = "";
          }
          // 加载状态结束
          this.loading = false;
          console.log("返回的数据：" + JSON.stringify(this.list));
        },
        error => {
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          this.finished = true;
        }
      );
    },
    onClickRight: function () {
      this.toLeaveApply();
    },
    onClickLeft: function () {
      this.$router.push({
        path: "/attenceflow/AttenceHome",
        query: {}
      });
    },
    holidayDesc(beginTime, endTime, day) {
      return "开始时间：" + beginTime + "，结束时间：" + endTime + "，请假天数：" + day;
    },
    holidayTitle(name, deptName, empNo) {
      return "请假人：" + name + "，部门：" + deptName;
    },
    jumpToApplyPage(status, taskId, processInstanceId, appNo, processDefinitionId) {
      if (status == 1) {
        this.$router.push({
          path: "/attenceflow/leave/form",
          query: {
            taskId: taskId,
            processInstanceId: processInstanceId,
            appNo: appNo,
            processDefinitionId: processDefinitionId,
            pageType: 1,
          }
        });
      } else if (status == 2) {
        Toast("当前申请审批中，不允许修改")
      } else if (status == 3) {
        Toast("审批已通过，不允许修改")
      }
    }
  },
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

.goods-card {
  margin: 0;
  background-color: @white;
}

.delete-button {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/leave/list.vue